<!--  -->
<template>
  <div class="sucess">
    <Topmenu />
    <div class="subbanner pr">
      <img src="@/assets/banner02.jpg" />
    </div>
    <div class="wrapcon">
      <div class="modelTit" id="caseyiliao"><img src="@/assets/casetit2.png" /></div>
      <div class="logolist">
        <ul>
          <li>
            <img src="@/assets/hoslogo1.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo2.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo3.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo4.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo5.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo6.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo7.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo8.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo9.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo10.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo11.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo12.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo13.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo14.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo15.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo16.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo17.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo18.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo19.png" />
          </li>
          <li>
            <img src="@/assets/hoslogo20.png" />
          </li>
        </ul>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Topmenu from '@/components/topmenu'
import Bottom from '@/components/bottom'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Topmenu, Bottom },
  data() {
    //这里存放数据
    return {}
  },
  created() {
    this.$nextTick(() => this.getLocal())
  },
  destroyed() {
    localStorage.setItem('anchorId', '')
  },
  methods: {
    getLocal() {
      let select = localStorage.getItem('anchorId')
      let ele = document.getElementById(select)

      if (select) {
        ele.scrollIntoView(true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.subbanner {
  width: 100%;
  height: 298px;
  overflow: hidden;
  img {
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
    margin-left: -960px;
    width: 1920px;
    height: 298px;
  }
}
.modelTit {
  display: block;
  margin: 50px auto 15px;
  text-align: center;
}
.logolist {
  width: 1120px;
  margin: 0 auto;
  overflow: hidden;
}
.logolist ul li {
  width: 180px;
  float: left;
  margin: 10px 5px;
  border: 1px solid #e0e0e0;
  padding: 5px 15px;
}
.logolist ul li img {
  margin: 0 auto;
  width: 180px;
}
.logolist2 ul li img {
  margin: 10px auto;
}
.icp {
  color: #fff;
}
.icp:hover {
  color: #078be4;
}

//@import url(); 引入公共css类
</style>
